import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntryByProductsfcc} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useGetPdpPlus = (productId) => {
    const {stack} = useContentstack()

    const {locale} = useMultiSite()

    const getPdpPlus = async () => {
        if (!productId) {
            return null
        }

        const response = await getEntryByProductsfcc({
            productId,
            stack,
            locale: locale.alias,
            contentTypeUid: 'pdpplus',
        })
        return response ? response[0] : null
    }

    const query = useQuery(['pdpplus'], () => getPdpPlus())

    return query
}
